import { isSmallLabCodesystem } from "components/search/buckets/utils";
import { useLocation } from "react-router-dom";
import { appendClassName } from "utils";

import { PagingInfoViewProps } from "./interface";
import { Wrapper } from "./style";

function PagingInfoView({
  className,
  //end,
  searchTerm,
  //start,
  totalResults,
  ...rest
}: PagingInfoViewProps & React.HTMLAttributes<HTMLDivElement>) {
  const { pathname } = useLocation();
  return (
    <Wrapper
      className={appendClassName("sui-paging-info", className)}
      {...rest}
    >
      {searchTerm && !isSmallLabCodesystem(pathname) && (
        <>
          <strong>{totalResults}</strong> treff for{" "}
          <strong>{searchTerm}</strong>
        </>
      )}

      {isSmallLabCodesystem(pathname) && (
        <>
          <strong>{totalResults}</strong> treff
          for <strong>{searchTerm}</strong>
        </>
      )}
    </Wrapper>
  );
}

export default PagingInfoView;
